import React from 'react';

import { Paper } from 'uiToolkitV1/Paper';
import { SkeletonLoader } from 'uiToolkitV1/SkeletonLoader';

const SkeletonLoaderReviewCreation = () => (
  <SkeletonLoader skeletons={['15px', '10px', '15px', '10px', '15px', '10px']} />
);

const SkeletonLoaderMultiViewVariant = () => (
  <Paper p="12px 16px 16px 16px" boxShadow="0px 2px 8px rgba(0, 0, 0, 0.08)" w="100%">
    <SkeletonLoaderReviewCreation />
  </Paper>
);

export { SkeletonLoaderReviewCreation, SkeletonLoaderMultiViewVariant };
